import React from "react";
import styles from "./Shift.module.css";
import { getScaleColorForPercentage, getContrastingTextColor } from "../../utils/colorUtils";

function Shift({ hours, startTime, endTime, colorConfig }) {
  // Helper function – parses "HH:MM:SS" and returns minutes since midnight (using hours and minutes only)
  const parseTime = (timeStr) => {
    const parts = timeStr.split(":");
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
  };

  // Calculate minutes for the start and end of the shift
  const startMins = parseTime(startTime); // e.g., for "07:15:00" → 435
  const endMins = parseTime(endTime); // e.g., for "15:45:00" → 945

  // Extract the hour part from the full time (e.g., 7 and 15)
  const startHourNum = parseInt(startTime.split(":")[0], 10);
  const endHourNum = parseInt(endTime.split(":")[0], 10);

  // Filter tiles: select hours between the start and end hour of the shift
  const filteredHours = hours.filter((item) => {
    const hr = parseInt(item.hour, 10);
    return hr >= startHourNum && hr <= endHourNum;
  });

  filteredHours.sort((a, b) => parseInt(a.hour, 10) - parseInt(b.hour, 10));

  const calculateAveragePercentage = () => {
    if (filteredHours.length === 0) return 0;
    const totalPercent = filteredHours.reduce((sum, item) => sum + item.percent, 0);
    return (totalPercent / filteredHours.length).toFixed(1);
  };

  const averagePercentage = calculateAveragePercentage();
  const scaleColor = getScaleColorForPercentage(averagePercentage, colorConfig);
  const textContrastColor = getContrastingTextColor(scaleColor);

  return (
    <div className={styles.shiftContainer}>
      <div className={styles.averagePercentageWrapper} style={{ backgroundColor: scaleColor, color: textContrastColor }}>
        <div className={styles.averagePercentageLabel}>Average for shift</div>
        <div className={styles.averagePercentage}>{averagePercentage}%</div>
      </div>
      {filteredHours.map((item, index) => {
        const tileHour = parseInt(item.hour, 10);
        let timeLabel = tileHour + ":00"; // default format

        // For the first tile of the shift, display the exact start time (e.g., "07:15")
        if (tileHour === startHourNum) {
          timeLabel = startTime.slice(0, 5);
        }
        // For the last tile of the shift, display the exact end time (e.g., "15:45")
        else if (tileHour === endHourNum) {
          timeLabel = endTime.slice(0, 5);
        }

        const scaleColor = getScaleColorForPercentage(item.percent, colorConfig);
        const textContrastColor = getContrastingTextColor(scaleColor);
        return (
          <div key={index}>
            <div className={styles.hourLabel}>{timeLabel}</div>
            <div className={styles.hourBlock} style={{ backgroundColor: scaleColor }}>
              <span className={styles.hourValue} style={{ backgroundColor: scaleColor, color: textContrastColor }}>
                {Math.floor(item.percent)}%
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Shift;
